import { publicRequest, BASE_URL } from "../requestMethods";
import { toast } from "react-toastify";

import {
  loginFailure,
  loginStart,
  loginSuccess,
  registerStart,
  registerSuccess,
  registerFailure,
  resetStart,
  resetSuccess,
  resetFailure,
  updateUserStart,
  updateUserSuccess,
  updateUserFailure,
} from "../redux/userRedux";

export const verifyEmail = async (mail, callback) => {
  try {
    return await publicRequest.post(`${BASE_URL}auth/verifymail`, mail);
  } catch (err) {
    // console.log(err, "err at verify mail api");
    callback(err?.response?.data?.err);
    return err;
  }
};

export const verifyOtp = async (otpData) => {
  console.log(otpData, "otp DATA");
  // try{
  return await publicRequest.post(`${BASE_URL}auth/verify/otp`, otpData);
  // }catch(err){
  //   // callback(err?.response?.data?.err)
  //   console.log(err, 'err at verify otp')
  //   return err;
  // }
};

export const register = async (dispatch, user, callback) => {
  dispatch(registerStart());
  try {
    const res = await publicRequest.post(`${BASE_URL}auth/register`, user);
    dispatch(registerSuccess(res.data));
    callback(res.data.message);
    // console.log(res.data);
  } catch (err) {
    callback(err?.response?.data?.err);
    // console.log(err?.response?.data.err, 'reg at err')
    dispatch(registerFailure());
  }
};

export const login = async (dispatch, user, callback) => {
  dispatch(loginStart());
  try {
    const res = await publicRequest.post(`${BASE_URL}auth/login`, user);
    console.log(res?.data?.accessToken, "login data");
    if (res.status === 200) {
      dispatch(loginSuccess(res.data));
      localStorage.setItem("UserDetailToken", res?.data?.accessToken);
      callback(res);
    }
  } catch (err) {
    dispatch(loginFailure());
  }
};

export const resetPassword = async (email, callback) => {
  // dispatch(resetStart());
  try {
  console.log(email, 'usermail')

    return await publicRequest.post(
      `${BASE_URL}auth/reset-password`,
      {email}
    );
    // dispatch(resetSuccess(res.data));
  } catch (err) {
    callback(err?.response?.data?.err);
    return err
  }
};

export const newPassword = async (user, callback) => {
  // dispatch(resetStart());
  try {
    return await publicRequest.post(`${BASE_URL}auth/new-password`, user);
    // dispatch(resetSuccess(res.data));
  } catch (err) {
    // dispatch(resetFailure());
    callback(err?.response?.data?.err);

    return err;
  }
};

export const updateUser = async (dispatch, userData, id) => {
  try {
    dispatch(updateUserStart());
    const res = await publicRequest.patch(
      `${BASE_URL}auth/update-profile/${id}`,
      userData
    );
    console.log(res, "res");
    toast.success(`🦄 ${res.data.message}`);
    dispatch(updateUserSuccess(res.data));
  } catch (err) {
    dispatch(updateUserFailure());
  }
};
